module.exports = __webpack_public_path__ + "img/Levy Asaytuno.3f020c43.jpg";